import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';

import { composeProps } from '@mews/framework';

import { ApplicationState } from '../../../types';
import { WithServiceId } from '../../../types/selectors/selectorPropTypes';
import { localizeText } from '../../globalization/selectors';
import { selectedEnterpriseIdPropsExtender } from '../../resourceOrder/selectors';
import { configurationEnterpriseIdExtender, getEnterprisePricingModeKey } from '../enterprises/selectors';
import { getServiceBookablePeriodTextKey, getServiceEnterpriseId, getServiceTimeUnitKey } from './selectors';

export const getResourceOrderServicePerTimeUnitKey = composeProps(
    getServiceTimeUnitKey({ perTimeUnit: true }),
    selectedEnterpriseIdPropsExtender
);

export const getConfigurationServiceTimeUnitKey = composeProps(
    (state, { enterpriseId }) =>
        enterpriseId != null ? getServiceTimeUnitKey({ perTimeUnit: true })(state, { enterpriseId }) : null,
    configurationEnterpriseIdExtender
);

const getResourceOrderServiceBookablePeriodTextKey = composeProps(
    getServiceBookablePeriodTextKey,
    selectedEnterpriseIdPropsExtender
);

export const getLocalizedResourceOrderServiceBookablePeriod = (state: ApplicationState) => {
    const bookablePeriodTextKey = getResourceOrderServiceBookablePeriodTextKey(state, {});

    return localizeText(bookablePeriodTextKey)(state);
};

export const getServiceEnterprisePricingModeKey = (state: ApplicationState, { serviceId }: WithServiceId) =>
    pipe(
        getServiceEnterpriseId(state, { serviceId }),
        option.fromNullable,
        option.chainNullableK((enterpriseId) => getEnterprisePricingModeKey(state, { enterpriseId }))
    );
